<template>
  <div class="meal-choose-table">
    <div class="table">
      <div class="title">
        <div class="left bold">基础版</div>
        <div class="right bold">说明</div>
      </div>

      <!-- <div class="row1">
        <div class="left bold">智工嗨搜基础版</div>
        <div class="right">
          <div class="top">
            <span>限时免费</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="海智铂金会员，钻石会员，VIP会员，VVIP会员限时特惠"
              placement="right"
            >
              <i class="iconfont icon-icon-xinxitishi"></i>
            </el-tooltip>
          </div>
          <div class="bottom">原价￥10,000.00/年</div>
        </div>
      </div> -->

      <div class="row2">
        <div class="col1 bold">海外买家数据搜索</div>
        <div class="col2">
          <div class="li">添加潜在客户</div>
          <div class="li">数据搜索限制</div>
          <div class="li">LinkedIn客户主页</div>
          <div class="li">公司信息查看</div>
        </div>
        <div class="col3">
          <div class="li">购买资源包后可用</div>
          <div class="li">无限制</div>
          <div class="li">仅查看</div>
          <div class="li">无限制</div>
        </div>
      </div>

      <div class="row3">
        <div class="col1 bold">邮件营销</div>
        <div class="col2">
          <div class="li">营销邮件群发</div>
          <div class="li">营销邮件效果分析</div>
          <div class="li">发送统计</div>
        </div>
        <div class="col3">
          <div class="li">购买资源包后可用</div>
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
        </div>
      </div>

      <div class="row4">
        <div class="col1 bold">客户管理</div>
        <div class="col2">
          <div class="li">潜在客户管理</div>
          <div class="li">客户公司信息维护</div>
          <div class="li">客户标签</div>
          <div class="li">潜在客户备注</div>
          <div class="li">客户日志追踪</div>
        </div>
        <div class="col3">
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
          <div class="li">
            <i class="iconfont icon-icon-feiloukong"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.meal-choose-table {
  padding-bottom: 48px;
  .table {
    width: 1040px;
    margin: 0 auto;
    box-sizing: border-box;
    color: #16181a;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }
    .bold {
      font-family: SourceHanSansCN-Medium;
    }
    .title {
      display: flex;
      background: #f3f5f8;
      border: 1px solid #cfd5df;
      // border-bottom: none;
      > .left {
        width: 406px;
        height: 78px;
        border-right: 1px solid #cfd5df;
      }
      > .right {
        flex: 1;
      }
    }
    .row1 {
      height: 90px;
      display: flex;
      border: 1px solid #cfd5df;
      border-top: none;
      > .left {
        height: 100%;
        width: 406px;
        border-right: 1px solid #cfd5df;
      }
      > .right {
        flex: 1;
        display: block;
        .top {
          display: flex;
          align-items: center;
          height: 14px;
        }
        .bottom {
          margin: 0 auto;
          width: 110px;
          position: relative;
          color: #98a3b7ff;
          font-size: 12px;
          margin-top: 6px;
          height: 14px;
          line-height: 14px;
          &::after {
            content: '';
            position: absolute;
            width: 114px;
            top: 8px;
            left: -1px;
            height: 1px;
            background-color: #98a3b7;
            transform: rotate(4deg);
          }
        }
        span {
          color: #ff7f2a;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          font-size: 14px;
          margin-right: 4px;
        }
        i {
          font-size: 14px;
          color: #4f5d78;
          cursor: pointer;
        }
      }
    }
    .row2,
    .row3,
    .row4 {
      display: flex;
      border: 1px solid #cfd5df;
      border-top: none;
      .col1 {
        width: 176px;
        height: 272px;
        border-right: 1px solid #cfd5df;
        font-weight: 500;
        font-size: 14px;
        color: #16181a;
      }
      .col2 {
        width: 230px;
        display: block;
        border-right: 1px solid #cfd5df;
        .li {
          width: 230px;
          display: block;
          height: 68px;
          line-height: 68px;
          border-bottom: 1px solid #cfd5df;
          &:last-child {
            border-bottom: none;
          }
        }
      }
      .col3 {
        flex: 1;
        display: block;
        .li {
          display: block;
          height: 68px;
          line-height: 68px;
          border-bottom: 1px solid #cfd5df;
          &:last-child {
            border-bottom: none;
          }
          i {
            font-size: 20px;
            color: #318ded;
          }
        }
      }
    }

    .row3 {
      .col1 {
        height: 204px;
      }
    }

    .row4 {
      .col1 {
        height: 340px;
      }
    }
  }
}
</style>
